<template>
  <div class="cloth_box">
    <!-- 使用 van-list 实现上拉加载 -->
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <template v-for="(item, index) in listData">
        <div
          class="shop_list"
          @click="go_info(item.id)"
          :id="item.id"
          :key="index"
        >
          <!-- 商品内容保持不变 -->
          <div class="left_img">
            <img :src="https + item.image" alt="" />
          </div>
          <div class="right_text">
            <div class="s_name">{{ item.title }}</div>
            <div>
              <span style="font-size: 13px">到手价：</span>
              <span style="color: red">￥</span>
              <span class="s_price">{{ item.price }}</span>
            </div>
            <div class="s_tro">{{ item.synopsis }}</div>
          </div>
        </div>
      </template>
    </van-list>
  </div>
</template>

<script>
import { searc_all } from "../../src/utils/request";
import axios from "axios";
export default {
  data() {
    return {
      page: 1,
      listData: [],
      https: "",
      loading: false, // 加载状态
      finished: false, // 是否全部加载完成
    };
  },
  methods: {
    go_info(id) {
      this.$router.push({
        path: "/shop_info",
        query: { goods_id: id },
      });
    },
    async onLoad() {
      // 上拉加载触发的方法
      if (this.finished) return;

      this.loading = true;
      try {
        const res = await searc_all({
          data: {
            value: this.$route.query.id,
            page: this.page,
          },
        });

        if (res.data.data.list.length === 0) {
          this.finished = true; // 无更多数据
        } else {
          this.listData = [...this.listData, ...res.data.data.list]; // 合并数据
          this.page++;
        }
      } catch (error) {
        console.error("加载失败:", error);
      } finally {
        this.loading = false;
      }
    },
  },
  async mounted() {
    this.https = axios.defaults.baseURL;
    // 初始化加载第一页
    this.onLoad();
  },
};
</script>

<style>
.shop_list {
  display: flex;
  margin-bottom: 20px;
}

.cloth_box {
  padding: 20px 20px 20px 15px;
}
.left_img {
  width: 36%;
  height: 140px;
  padding: 6px;
  box-sizing: border-box;
}
.left_img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
  display: block;
}
.right_text {
  width: 64%;
  text-align: left;
  padding: 4px 6px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.s_name {
  font-size: 16px;
  font-weight: 700;
}
.s_price {
  color: red;
  font-size: 16px;
}
.s_tro {
  color: #7e7c7c;
  font-size: 10px;
}
.old_price {
  color: #a29e9e;
  font-size: 13px;
  text-decoration: line-through;
}

/* 确保列表容器有滚动空间 */
.cloth_box {
  padding: 20px 20px 20px 15px;
  min-height: calc(100vh - 100px); /* 避免内容过短无法触发滚动 */
}

/* 加载状态提示样式 */
.van-list__loading,
.van-list__finished-text {
  padding: 10px 0;
  text-align: center;
  color: #969799;
}
</style>